import React from "react";
import { useRoles } from "../../context/RolesContext";
import { Component } from "react";
import { Container } from "react-bootstrap";
import SpinnerPage from "../spinner/spinner";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import styles from "./listing.module.css";
import Onboarding from "../deviceOnBoarding/onBoarding";
import axios from "axios";
import * as config from "../../config";
import { NavLink } from "react-router-dom";

export type columnDefinition = {
  label: string;
  field: string;
  sort: string;
};

export type rowData = {
  model: string;
  generation: string;
  imei: string;
  vin: string;
  channels: string[];
  security: any;
  lastModiedDate: string;
  lastModifiedBy: string;
  make: string;
  tags: string;
  capabilities: string[];
  action: any;
  status: any;
};

const tableDef = [
  "model",
  "generation",
  "imei",
  "vin",
  "channels",
  "lastModiedDate",
  "lastModifiedBy",
  "make",
  "tags",
  "capabilities",
  "status",
  "action",
];

export type dataTable = {
  columns: columnDefinition[];
  rows: rowData[];
};

let prevselectedEnv = localStorage.getItem("selectedEnv");

class DeviceListing extends Component<any, any> {
  dict: { [key: string]: boolean } = {};
  constructor(props: any) {
    super(props);
    this.state = {
      sortField: null,
      sortOrder: "asc",
      currentPage: 1,
      rowsPerPage: 5,
      editonBoard: false,
      editdataonboard: {},
      alldeviceState: localStorage.getItem("alldeviceState"),
      tableData: { columns: [], rows: [] },
      modal: false,
      editData: null,
      error: null,
      showErrorModal: false,
      showUnauthorized: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    // Initial API calls
    const initialEnv = localStorage.getItem("selectedEnv") || "tyau_sydney";
    this.callDeviceAPIs(initialEnv);

    // Listen for environment changes
    window.addEventListener("envChanged", this.handleEnvChangeEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("envChanged", this.handleEnvChangeEvent);
  }

  handleEnvChangeEvent = (event: any) => {
    const newEnv = event.detail;
    console.log("Environment changed to:", newEnv);
    this.callDeviceAPIs(newEnv);
  };
  callDeviceAPIs = (env: string) => {
    // API 1: get-all-status-db
    axios
      .get(`${config.rootUrl}/v1/simulator/get-all-status-db`, {
        headers: {
          "x-api-key": config.apiKey,
          "X-Environment": env,
          Authorization: `Bearer ${this.props.jwtToken}`,
        },
      })
      .then((res) => {
        console.log("get-all-status-db:", res.data);
        localStorage.setItem("alldeviceState", res.data.sendactivedata);
        this.setState({ alldeviceState: res.data.sendactivedata === "true" });

        // Save status per VIN
        res.data.vinactivestatusmap?.forEach((item: string) =>
          localStorage.setItem(`${item}-status`, "active")
        );
        res.data.vininactivestatusmap?.forEach((item: string) =>
          localStorage.setItem(`${item}-status`, "inactive")
        );
      })
      .catch((err) => console.error(err));

    // API 2: get devices
    fetch(`${config.rootUrl}/v1/configuration/devices`, {
      method: "GET",
      headers: {
        "x-api-key": config.apiKey,
        Authorization: `Bearer ${this.props.jwtToken}`,
        "X-Environment": env,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data?.Items) return console.error("No devices found");
        // Process table data as before...
        if (data?.Items) {
          const columnDef: columnDefinition[] = tableDef.map((element) => ({
            label: capitalizeFirstLetter(element),
            field: element,
            sort: "enabled",
          }));

          const rowData: rowData[] = data.Items.map(
            (element: rowData, i: number) => {
              this.dict[element.vin] = true;
              return {
                model: element.model,
                generation: element.generation,
                imei: element.imei,
                vin: element.vin ? (
                  <NavLink
                    key={i}
                    className="link-new custom_NavStyle"
                    to={"/device-twin?deviceid=" + element.vin}
                  >
                    {element.vin}
                  </NavLink>
                ) : (
                  <span>No VIN</span>
                ),
                channels: element.channels ? element.channels.join(",") : "",
                lastModiedDate: element.lastModiedDate
                  ? new Date(
                    parseInt(element.lastModiedDate) * 1000
                  ).toISOString()
                  : "",
                lastModifiedBy: element.lastModifiedBy,
                make: element.make,
                tags: element.tags,
                capabilities: element.capabilities
                  ? element.capabilities.join(",")
                  : "",
                status: this.renderStatusCheckbox(element),
                action: (
                  <div className="pt-1 pl-3">
                    <button
                      className="btn-nostyle"
                      aria-label="Edit"
                      onClick={() => this.viewDetails(element, "edit")}
                    >
                      <i className="fas fa-edit" />
                    </button>
                  </div>
                ),
              };
            }
          );

          const tableInfo: dataTable = { columns: columnDef, rows: rowData };
          this.setState({ tableData: tableInfo });
        } else {
          console.error("No data found for devices.");
        }
      })
      .catch((err) => console.error(err));
  };

  renderStatusCheckbox(data: rowData) {
    const vinStatusKey = `${data.vin}-status`;
    const status = localStorage.getItem(vinStatusKey) || "active";
    const isActive = status === "active";

    return (
      <div className="smallSwitchToggle">
        <input
          onChange={() => {
            this.devicelisttoggle(data);
          }}
          type="checkbox"
          id={data.vin + "-checkbox"}
          className="doorinput"
          checked={isActive}
        />
        <label
          id="button"
          htmlFor={data.vin + "-checkbox"}
          className="doorinputlabel"
        >
          <div className="knob"></div>
          <div className="lock">Active</div>
          <div className="unlock">Inactive</div>
        </label>
      </div>
    );
  }

  viewDetails = (data: rowData, action: string) => {
    this.setState({
      modal: true,
      editData: data,
      editonBoard: true,
    });
  }

  closeMedal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  closeUnauthorized = () => {
    this.setState({ showUnauthorized: false });
  };

  devicelisttoggle(data: rowData) {
    const vinStatusKey = `${data.vin}-status`;
    const currentStatus = localStorage.getItem(vinStatusKey) || "active";
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const vin = `${data.vin}`;

    localStorage.setItem(vinStatusKey, newStatus);

    this.setState((prevState: any) => ({
      tableData: {
        ...prevState.tableData,
        rows: prevState.tableData.rows.map((row: any) => {
          if (row.vin.props.children === data.vin) {
            return {
              ...row,
              status: this.renderStatusCheckbox({ ...data, status: newStatus }),
            };
          }
          return row;
        }),
      },
    }));

    axios
      .post(
        config.rootUrl + "/v1/simulator/update-status",
        {
          ...data,
          status: newStatus,
        },
        {
          headers: {
            "x-api-key": config.apiKey,
            Authorization: "Bearer " + this.props.jwtToken,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("Status updated successfully");
        }
      })
      .catch((error) => {
        console.error("Error updating status:", error);
      });
  }

  handleConnButtonClick = async () => {
    let addconnenv = localStorage.getItem("selectedEnv") || "tyau_sydney";

    try {
      const response = await fetch(
        config.rootUrl + "/v1/simulator/refresh-connection",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Environment": addconnenv,
            Authorization: "Bearer " + this.props.jwtToken,
          },
          body: JSON.stringify({ message: "Resume connection" }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Response from server:", data);

      try {
        const statusResponse = await axios.get(
          config.rootUrl + "/v1/simulator/get-all-status-db",
          {
            headers: {
              "x-api-key": config.apiKey,
              "X-Environment": addconnenv,
              Authorization: "Bearer " + this.props.jwtToken,
            },
          }
        );
        const statusData = statusResponse.data;

        this.dict = {};
        console.log(statusData);
        localStorage.setItem("alldeviceState", statusData.sendactivedata);
        this.setState({
          alldeviceState: statusData.sendactivedata === "true",
        });

        if (statusData.vinactivestatusmap.length > 0) {
          console.log("inside active array");
          for (let item of statusData.vinactivestatusmap) {
            localStorage.setItem(`${item}-status`, "active");
          }
        }

        if (statusData.vininactivestatusmap.length > 0) {
          console.log("inside inactive array");
          for (let item of statusData.vininactivestatusmap) {
            localStorage.setItem(`${item}-status`, "inactive");
          }
        }
      } catch (error) {
        console.error("Error fetching records:", error);
      }

      fetch(config.rootUrl + "/v1/configuration/devices", {
        method: "GET",
        headers: new Headers({
          "x-api-key": config.apiKey,
          Authorization: "Bearer " + this.props.jwtToken,
          "X-Environment": addconnenv,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.Items) {
            let columnDef: columnDefinition[] = tableDef.map((element) => {
              return {
                label: capitalizeFirstLetter(element),
                field: element,
                sort: "enabled",
              };
            });

            let rowData: rowData[] = data.Items.map(
              (element: rowData, i: any) => {
                this.dict[element.vin] = true;
                return {
                  model: element.model,
                  generation: element.generation,
                  imei: element.imei,
                  vin: element.vin ? (
                    <NavLink
                      key={i}
                      className="link-new custom_NavStyle"
                      to={"/device-twin?deviceid=" + element.vin}
                    >
                      {element.vin}
                    </NavLink>
                  ) : (
                    <span>No VIN</span>
                  ),
                  channels: element.channels ? element.channels.join(",") : "",
                  lastModiedDate: element.lastModiedDate
                    ? new Date(
                      parseInt(element.lastModiedDate) * 1000
                    ).toISOString()
                    : "",
                  lastModifiedBy: element.lastModifiedBy,
                  make: element.make,
                  tags: element.tags,
                  capabilities: element.capabilities
                    ? element.capabilities.join(",")
                    : "",
                  status: this.renderStatusCheckbox(element),
                  action: (
                    <div className="pt-1 pl-3">
                      <button
                        className="btn-nostyle"
                        aria-label="Edit"
                        onClick={() => {
                          this.viewDetails(element, "edit");
                        }}
                      >
                        <i className="fas fa-edit" />
                      </button>
                    </div>
                  ),
                };
              }
            );

            let tableInfo: dataTable = {
              columns: columnDef,
              rows: rowData,
            };
            this.setState({ tableData: tableInfo });
          } else {
            console.error("No data found for devices.");
          }
        })
        .catch((error) => {
          console.error("Error fetching devices:", error);
        });
    } catch (error) {
      console.error("Error adding connection:", error);
      this.setState({ error: "Failed to refresh connection" });
    }
  };

  devicelisttoggleAll = () => {
    const storage = localStorage.getItem("alldeviceState") === "true";
    const newState = !storage;
    localStorage.setItem("alldeviceState", newState.toString());
    this.setState({ alldeviceState: newState });

    const allCheckboxes = document.querySelectorAll(".doorinput");
    allCheckboxes.forEach((checkbox) => {
      if (checkbox instanceof HTMLInputElement) {
        checkbox.checked = newState;
      }
    });

    const data = {
      envvariable: localStorage.getItem("selectedEnv"),
      statusvariable: newState ? "active" : "inactive",
    };
    axios
      .post(
        config.rootUrl + "/v1/simulator/update-status-all-db",
        {
          data,
        },
        {
          headers: {
            "x-api-key": config.apiKey,
            Authorization: "Bearer " + this.props.jwtToken,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("Updated all DB");
        }
      })
      .catch((error) => {
        console.error(
          "There was an error updating the status for all DB!",
          error
        );
      });

    for (const key in this.dict) {
      if (this.dict.hasOwnProperty(key)) {
        localStorage.setItem(key + "-status", newState ? "active" : "inactive");
      }
    }
  };

  private getCellValue(value: any): string {
    if (React.isValidElement(value)) {
      const element = value as React.ReactElement;
      if (typeof element.props.children === "string") {
        return element.props.children.toLowerCase();
      }
      if (Array.isArray(element.props.children)) {
        return element.props.children
          .map((child: any) =>
            typeof child === "string" ? child.toLowerCase() : ""
          )
          .join(" ");
      }

      return "";
    }

    if (Array.isArray(value)) {
      return value.join(" ").toLowerCase();
    }

    return value?.toString().toLowerCase() || "";
  }

  render() {
    const {
      tableData,
      currentPage,
      rowsPerPage,
      sortField,
      sortOrder,
      searchTerm,
    } = this.state;

    if (this.state.error) {
      return (
        <div
          className={styles.errorContainer}
          role="alert"
          style={{ color: "red", padding: "20px" }}
        >
          {this.state.error}
        </div>
      );
    }

    if (!this.state.tableData.rows.length) {
      return (
        <div className={styles.spinner}>
          <SpinnerPage />
        </div>
      );
    }

    const filteredRows = tableData.rows.filter((row: rowData) =>
      tableData.columns.some((col: columnDefinition) => {
        const value = (row as any)[col.field];
        return this.getCellValue(value).includes(
          searchTerm?.toLowerCase() || ""
        );
      })
    );

    const sortedRows = [...filteredRows].sort((a: any, b: any) => {
      if (!sortField) return 0;
      const aVal = this.getCellValue(a[sortField]);
      const bVal = this.getCellValue(b[sortField]);
      if (aVal === bVal) return 0;
      if (sortOrder === "asc") return aVal > bVal ? 1 : -1;
      return aVal < bVal ? 1 : -1;
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = sortedRows.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(sortedRows.length / rowsPerPage);

    return (
      <>
        <MDBModal
          show={this.state.showUnauthorized}
          setShow={this.closeUnauthorized}
          tabIndex="-1"
        >
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <h5 style={{ color: "#dc3545", fontWeight: 600, margin: 0 }}>
                  <i className="fas fa-lock me-2"></i>Access Denied
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={this.closeUnauthorized}
                />
              </MDBModalHeader>
              <MDBModalBody className="text-center">
                <i
                  className="fas fa-exclamation-triangle"
                  style={{
                    fontSize: "50px",
                    color: "#ffc107",
                    marginBottom: "20px",
                  }}
                ></i>
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                  You do not have permission to perform this action.
                </p>
                <p style={{ fontSize: "14px", color: "#666" }}>
                  Please contact your administrator to request access.
                </p>
              </MDBModalBody>
              <MDBModalFooter>
                <button
                  className="btn btn-outline-secondary"
                  onClick={this.closeUnauthorized}
                  style={{
                    borderColor: "#9c27b0",
                    color: "#9c27b0",
                    fontWeight: 500,
                    boxShadow: "0px 2px 4px rgba(156, 39, 176, 0.4)",
                  }}
                >
                  CLOSE
                </button>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        <Container fluid className={styles.datatable}>
          <div className="d-flex justify-content-start align-items-center mt-4">
            <h5 className="font-weight-bold mb-0 mr-5">Vehicles</h5>
            <input
              type="text"
              className="form-control w-auto "
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) =>
                this.setState({ searchTerm: e.target.value, currentPage: 1 })
              }
            />
          </div>

          <div>
            <button
              className="btn btn-primary"
              style={{
                position: "absolute",
                top: "115px",
                left: "260px",
                zIndex: 10,
              }}
              onClick={this.handleConnButtonClick}
            >
              Refresh Connections
            </button>
          </div>

          <div className="allstatus">
            <label className="allstatusname">All Status</label>
            <div className="smallSwitchToggle">
              <input
                type="checkbox"
                id="All-checkbox"
                onChange={this.devicelisttoggleAll}
                className="doorinput"
                checked={this.state.alldeviceState}
              />
              <label
                id="button"
                htmlFor="All-checkbox"
                className="doorinputlabel"
              >
                <div className="knob"></div>
                <div className="lock">Active</div>
                <div className="unlock">Inactive</div>
              </label>
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className={`table table-hover ${styles.fixedTable}`}>
              <thead>
                <tr>
                  {tableData.columns.map((col: columnDefinition) => (
                    <th
                      key={col.field}
                      data-field={col.field}
                      className={styles.fixedCell}
                      onClick={() =>
                        this.setState({
                          sortField: col.field,
                          sortOrder:
                            sortField === col.field && sortOrder === "asc"
                              ? "desc"
                              : "asc",
                        })
                      }
                    >
                      {col.label}{" "}
                      {sortField === col.field && (
                        <i
                          className={`fas fa-sort-${sortOrder === "asc" ? "up" : "down"
                            } ms-1`}
                        ></i>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentRows.map((row: rowData, idx: number) => (
                  <tr key={idx}>
                    {tableData.columns.map((col: columnDefinition) => (
                      <td
                        key={col.field}
                        data-field={col.field}
                        className={styles.fixedCell}
                      >
                        {Array.isArray((row as any)[col.field])
                          ? (row as any)[col.field].join(", ")
                          : (row as any)[col.field]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center ms-auto">
              <div className="d-flex align-items-center">
                <span className="me-2">Rows per page:</span>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "auto" }}
                  value={rowsPerPage}
                  onChange={(e) =>
                    this.setState({
                      rowsPerPage: Number(e.target.value),
                      currentPage: 1,
                    })
                  }
                >
                  {[5, 10, 15].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                <span className="ms-3">
                  {indexOfFirstRow + 1} -{" "}
                  {Math.min(indexOfLastRow, sortedRows.length)} of{" "}
                  {sortedRows.length}
                </span>
              </div>
              <ul className="pagination mb-0 me-3">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    type="button"
                    className="ml-4 page-link fs-2 fw-bold"
                    onClick={() =>
                      this.setState({ currentPage: currentPage - 1 })
                    }
                  >
                    ‹
                  </button>
                </li>
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    type="button"
                    className="page-link fs-2 fw-bold"
                    onClick={() =>
                      this.setState({ currentPage: currentPage + 1 })
                    }
                  >
                    ›
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {this.state.modal && (
            <div className="modal show d-block d-flex align-items-center justify-content-center" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", zIndex: 1050 }}>
<div className="modal-dialog" style={{ maxWidth: "90%", width: "900px" }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Device</h5>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={this.closeMedal}
                    />
                  </div>
                  <div className="modal-body">
                    {this.state.editData && (
                      <Onboarding
                        closeMedal={this.closeMedal}
                        jwtToken={this.props.jwtToken}
                        editData={this.state.editData}
                        editdataonboard={this.state.editdataonboard}
                        editonBoard={this.state.editonBoard}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Container>
      </>
    );
  }
}

function capitalizeFirstLetter(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function DeviceListingWithRoles(props: any) {
  const { roles } = useRoles();
  return <DeviceListing {...props} roles={roles} />;
}

export default DeviceListingWithRoles;